// Create a new overlayStore instance.
const overlayStore = {
    namespaced: true,
    state() {
        return {
        }
    },
    mutations: {   
    }
}

export default overlayStore
